/** Angular imports */
import { CommonModule } from '@angular/common';
import { Component, computed, model, output } from '@angular/core';

/** Component imports */
import { Button, Modal } from '@ntv360/component-pantry';

/** Local imports */
import { DealerSelectionBaseComponent } from '../dealer-selection-base/dealer-selection-base.component';

@Component({
    selector: 'app-filter-by-user-modal',
    standalone: true,
    imports: [CommonModule, Modal, Button, DealerSelectionBaseComponent],
    templateUrl: './filter-by-user-modal.component.html',
    styleUrl: './filter-by-user-modal.component.scss',
})
export class FilterByUserModalComponent {
    /**
     * Two-way binding flag indicating whether or not the modal is visible
     */
    public isVisible = model<boolean>(false);

    /**
     * Two-way binding for the selected dealer
     */
    public selectedDealer = model<{ label: string; value: string }[]>([]);

    /**
     * Two-way binding for the selected host
     */
    public selectedHost = model<{ label: string; value: string }[]>([]);

    /**
     * Two-way binding for the selected advertiser
     */
    public selectedAdvertiser = model<{ label: string; value: string }[]>([]);

    /**
     * Emits when the modal is closed
     */
    public closeModal = output<void>();

    /**
     * Emits the filter event with the selected dealer and host
     */
    public filter = output<{
        ownerId: string | null;
        hostId: string | null;
        advertiserId: string | null;
    }>();

    /**
     * Reactive flag to check if the filter button should be disabled if no dealer is selected yet
     */
    protected disableFilterButton = computed(() => this.selectedDealer().length === 0);

    /**
     * Emits the filter event with the selected dealer, host, and/or advertiser is/are selected
     */
    protected onFilter() {
        this.filter.emit({
            ownerId: this.selectedDealer()?.[0]?.value ?? null,
            hostId: this.selectedHost()?.[0]?.value ?? null,
            advertiserId: this.selectedAdvertiser()?.[0]?.value ?? null,
        });
        this.isVisible.set(false);
    }

    /**
     * Emits the close modal event
     */
    protected onClose(): void {
        this.isVisible.set(false);
    }
}
